import React from "react";
import logo from '../assets/logo.png';

const Header = () => {
  return (
    <div>
      {/* Top Bar */}
      <div className="top-bar-area inc-pad bg-theme text-light">
        <div className="container">
          <div className="row d-flex justify-content-between">
            <div className="col-lg-6 info">
             <ul>
                <li style={{fontWeight:'500'}}>
                  <i className="fa fa-envelope-open"></i>vibes@knackhook.com
                </li>
              </ul>
            </div>
            <div className="col-lg-6 item-flex">
              <div className="social">
                <ul className="d-flex">
                  <li>
                    <a href="https://www.facebook.com/knackhook/" target="_blank" aria-label="Facebook" rel="noreferrer">
                      <i className="fa fa-facebook-f top-icon"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/Knack_Hook" target="_blank" aria-label="Twitter" rel="noreferrer">
                      <i className="fa fa-twitter top-icon"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/knackhook/mycompany/" target="_blank" aria-label="LinkedIn" rel="noreferrer">
                      <i className="fa fa-linkedin top-icon"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light">
        <div className="container d-flex justify-content-between">
          <a className="navbar-brand" href="#">
            <img
              src={logo}
              className="img-fluid"
              style={{ height: "65px" }}
              alt="Knackhire Logo"
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="/#Home">
                  HOME
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#About">
                  ABOUT
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#Keybenifits">
                  KEY BENEFITS
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#PricingPlans">
                  PRICING
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#Help">
                  HELP
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/privacy-policy">
                  PRIVACY POLICY
                </a>
              </li>
              <li className="nav-item">
                
                <a className="nav-link" href="/#Tour">
                <button className="btn btn-primary text-white" style={{fontSize:'12px'}}> PRODUCT TOUR </button> 
                </a>
                
              </li>
            </ul>

            <ul className="d-flex">
              <li className="call-icons">
                <i className="fa fa-phone"></i>
              </li>
              <li className="contact">
                <p>Call us today!</p>
                <p>
                  <strong>+1 (425) 548-6321</strong>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Styles */}
      <style jsx>{`
        .top-bar-area.bg-theme {
          border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        }
        .top-bar-area.inc-pad {
          padding: 15px 0;
        }
        .bg-theme {
          background-color: #2e3192;
        }
        .top-bar-area.bg-dark .info li i,
        .top-bar-area.bg-theme .info li i {
          color: #ffffff;
        }
        .top-bar-area .info li i {
          margin-right: 5px;
          color: #2e3192;
        }
        .social {
          float: right;
        }
        .top-icon {
          margin-right: 20px;
        }
        a.navbar-brand {
          margin-right: 142px;
        }
       li.nav-item {
    margin-right: 10px;
    font-size: 13px;
    font-weight: 500;
}
        li.call-icons {
          margin-right: 20px;
          border-right: 1px rgb(215, 215, 215) solid;
          height: 70px;
          padding: 20px;
          color: #2e3192;
          font-size: 30px;
        }

        /* Responsive Styles */
        @media (max-width: 992px) {
          .navbar-collapse {
            justify-content: center;
          }

          .navbar-nav {
            text-align: center;
          }

          a.navbar-brand {
            margin-right: 0;
          }

          .call-icons {
            margin-right: 10px;
            font-size: 25px;
          }

          .contact p {
            font-size: 14px;
          }
        }

        @media (max-width: 768px) {
          .top-bar-area .info {
            display: none;
          }

          .social {
            text-align: center;
            margin-top: 10px;
          }

          .navbar-nav {
            margin-top: 10px;
          }

          .top-bar-area {
            padding: 10px 0;
          }

          .contact p {
            font-size: 12px;
          }
        }

        @media (max-width: 576px) {
          .navbar-nav .nav-item {
            font-size: 14px;
            margin-right: 10px;
          }

          .navbar-nav {
            font-size: 14px;
          }

          .contact p {
            font-size: 10px;
          }

          .call-icons {
            font-size: 20px;
          }

          .top-bar-area {
            padding: 8px 0;
          }

          .top-bar-area .info li {
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default Header;
